export const services = [
  {
    id: "svc-mudanzas",
    slug: "mudanzas",
    titulo: "Mudanzas",
    descripcion:
      "Transporte seguro de muebles, equipos y pertenencias para hogares y oficinas, con embalaje y personal de carga.",
    icono: "ri-home-4-line",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Professional%20moving%20truck%20parked%20in%20front%20of%20a%20bright%20modern%20house%20with%20neatly%20stacked%20cardboard%20boxes%20and%20wrapped%20furniture%20ready%20for%20loading%2C%20clean%20minimalist%20background%2C%20soft%20natural%20daylight%2C%20cool%20blue%20and%20white%20tones%2C%20editorial%20logistics%20photography%20with%20sharp%20detail&width=900&height=640&seq=axonia-svc-mudanzas-01&orientation=landscape",
    destacado: true,
    orden: 1,
  },
  {
    id: "svc-acarreo",
    slug: "acarreo",
    titulo: "Acarreo",
    descripcion:
      "Soluciones de transporte para cargas, materiales de construcción e insumos que requieren rapidez y capacidad.",
    icono: "ri-truck-line",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Cargo%20truck%20loaded%20with%20construction%20materials%20and%20industrial%20supplies%20at%20a%20clean%20logistics%20yard%2C%20bright%20neutral%20background%2C%20soft%20overcast%20lighting%2C%20cool%20blue%20and%20grey%20tones%2C%20professional%20editorial%20industrial%20photography%2C%20high%20detail&width=900&height=640&seq=axonia-svc-acarreo-01&orientation=landscape",
    destacado: true,
    orden: 2,
  },
  {
    id: "svc-eventos",
    slug: "transporte-para-eventos",
    titulo: "Transporte para eventos",
    descripcion:
      "Vehículos y unidades para eventos, producciones y actividades especiales, con coordinación de horarios.",
    icono: "ri-calendar-event-line",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Event%20production%20van%20with%20stage%20equipment%2C%20trusses%20and%20speaker%20cases%20being%20loaded%20beside%20an%20outdoor%20event%20venue%2C%20clean%20minimal%20background%2C%20soft%20evening%20light%20with%20cool%20blue%20tint%2C%20editorial%20event%20logistics%20photography%2C%20sharp%20focus&width=900&height=640&seq=axonia-svc-eventos-01&orientation=landscape",
    destacado: true,
    orden: 3,
  },
  {
    id: "svc-distribucion",
    slug: "distribucion",
    titulo: "Distribución",
    descripcion:
      "Camiones y furgonetas para reparto y distribución, con rutas organizadas y entregas puntuales.",
    icono: "ri-route-line",
    imagen_url:
      "https://readdy.ai/api/search-image?query=White%20delivery%20van%20parked%20on%20a%20clean%20city%20street%20with%20parcel%20trolleys%20and%20stacked%20boxes%2C%20minimal%20urban%20background%2C%20soft%20morning%20light%2C%20cool%20blue%20and%20white%20palette%2C%20professional%20editorial%20logistics%20photography%2C%20crisp%20detail&width=900&height=640&seq=axonia-svc-distribucion-01&orientation=landscape",
    destacado: true,
    orden: 4,
  },
  {
    id: "svc-empresarial",
    slug: "transporte-empresarial",
    titulo: "Transporte empresarial",
    descripcion:
      "Unidades dedicadas y planes de transporte para empresas que necesitan movilidad constante y confiable.",
    icono: "ri-building-2-line",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Fleet%20of%20matching%20white%20commercial%20trucks%20parked%20in%20a%20tidy%20corporate%20logistics%20yard%20with%20office%20building%20in%20the%20background%2C%20clean%20minimal%20composition%2C%20soft%20daylight%2C%20cool%20blue%20tones%2C%20professional%20corporate%20photography%2C%20high%20detail&width=900&height=640&seq=axonia-svc-empresarial-01&orientation=landscape",
    destacado: false,
    orden: 5,
  },
  {
    id: "svc-grupos",
    slug: "transporte-para-grupos",
    titulo: "Transporte para grupos",
    descripcion:
      "Autobuses y unidades para movilización de personas en giras, traslados corporativos y excursiones.",
    icono: "ri-bus-2-line",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Modern%20white%20coach%20bus%20travelling%20on%20an%20open%20highway%20with%20clear%20blue%20sky%2C%20minimal%20clean%20background%2C%20soft%20natural%20lighting%2C%20cool%20blue%20tones%2C%20professional%20editorial%20transport%20photography%2C%20sharp%20detail&width=900&height=640&seq=axonia-svc-grupos-01&orientation=landscape",
    destacado: false,
    orden: 6,
  },
  {
    id: "svc-especiales",
    slug: "servicios-especiales",
    titulo: "Servicios especiales",
    descripcion:
      "Solicitudes personalizadas según la necesidad del cliente: cargas sobredimensionadas, montajes y más.",
    icono: "ri-settings-5-line",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Special%20purpose%20truck%20with%20hydraulic%20platform%20handling%20oversized%20industrial%20equipment%20in%20a%20clean%20open%20yard%2C%20minimal%20bright%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20steel%20grey%20tones%2C%20professional%20industrial%20photography%2C%20high%20detail&width=900&height=640&seq=axonia-svc-especiales-01&orientation=landscape",
    destacado: false,
    orden: 7,
  },
];